module.exports = __webpack_public_path__ + "static/media/orquestra_salao_9.d5b0f14e.jpg";